import { CellProps } from 'react-table';
import { TableCustomCell } from '../../../../component/table/components/TableCustomCell';
import { formatMoney } from '../../../../utils/FormatUtils';

const IntoMoneyCell = ({ row, tableOptions }: CellProps<any>) => {
	const { getObjectPriceFieldConfig } = tableOptions;
	const rowData = row.original;
	const unitPrice =
		rowData?.attributes?.[getObjectPriceFieldConfig(rowData?.visitObjectType?.code)] ?? 0;
	const quantity = rowData?.attributes?.svcQuantity ?? 1;
	const totalPrice = unitPrice * quantity;

	return <TableCustomCell className="text-end " data={formatMoney(totalPrice)} />;
};

export default IntoMoneyCell;
